import { getUid } from "../../auth";
import {
  doc,
  getFirestore,
  collection,
  updateDoc,
  setDoc,
  arrayUnion,
  getDocs,
  getDoc,
  runTransaction,
  orderBy,
  query,
  arrayRemove,
  deleteDoc,
} from "firebase/firestore";
import { getCollectionRef, getDocRef } from "../utils";

export async function getGroupCollection() {
  const db = getFirestore();
  const groupsCollection = collection(db, `/groups`);

  const querySnapshot = await getDocs(groupsCollection, {
    orderBy: "name",
  });

  const groups = querySnapshot.docs.map((doc) => doc.data());

  return groups;
}
